import { render, staticRenderFns } from "./InjectionCharts.vue?vue&type=template&id=e27ca314&scoped=true"
import script from "./InjectionCharts.vue?vue&type=script&lang=js"
export * from "./InjectionCharts.vue?vue&type=script&lang=js"
import style0 from "./InjectionCharts.vue?vue&type=style&index=0&id=e27ca314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ca314",
  null
  
)

export default component.exports